// src/composables/useUnreadMessages.js
import { storeToRefs } from 'pinia';
import { useUnreadMessagesStore } from '@/stores/unreadMessagesStore';

export function useUnreadMessages() {
  const store = useUnreadMessagesStore();
  const { unreadCount, isLoading, error } = storeToRefs(store);

  // Store'u yönetmek için metodları döndür
  return {
    unreadCount,
    isLoading,
    error,
    startListening: store.startListening,
    stopListening: store.stopListening,
    clearError: store.clearError,
  };
}
